var map = {
	"./ion-action-sheet-controller_8.entry.js": [
		"0BR9",
		0,
		129
	],
	"./ion-action-sheet-ios.entry.js": [
		"bnjm",
		0,
		130
	],
	"./ion-action-sheet-md.entry.js": [
		"utt2",
		0,
		131
	],
	"./ion-alert-ios.entry.js": [
		"yaSn",
		0,
		132
	],
	"./ion-alert-md.entry.js": [
		"2/RY",
		0,
		133
	],
	"./ion-app_8-ios.entry.js": [
		"iInF",
		0,
		134
	],
	"./ion-app_8-md.entry.js": [
		"K9Nc",
		0,
		135
	],
	"./ion-avatar_3-ios.entry.js": [
		"hH1s",
		0,
		136
	],
	"./ion-avatar_3-md.entry.js": [
		"Jw9y",
		0,
		137
	],
	"./ion-back-button-ios.entry.js": [
		"ouVF",
		0,
		138
	],
	"./ion-back-button-md.entry.js": [
		"/joy",
		0,
		139
	],
	"./ion-backdrop-ios.entry.js": [
		"uJLv",
		140
	],
	"./ion-backdrop-md.entry.js": [
		"fSmE",
		141
	],
	"./ion-button_2-ios.entry.js": [
		"s1jK",
		0,
		142
	],
	"./ion-button_2-md.entry.js": [
		"Wou7",
		0,
		143
	],
	"./ion-card_5-ios.entry.js": [
		"qshq",
		0,
		144
	],
	"./ion-card_5-md.entry.js": [
		"Q1uX",
		0,
		145
	],
	"./ion-checkbox-ios.entry.js": [
		"059i",
		0,
		146
	],
	"./ion-checkbox-md.entry.js": [
		"eLfv",
		0,
		147
	],
	"./ion-chip-ios.entry.js": [
		"+FzG",
		0,
		148
	],
	"./ion-chip-md.entry.js": [
		"yRpg",
		0,
		149
	],
	"./ion-col_3.entry.js": [
		"/CAe",
		150
	],
	"./ion-datetime_3-ios.entry.js": [
		"Z1Jy",
		0,
		151
	],
	"./ion-datetime_3-md.entry.js": [
		"X0Dk",
		0,
		152
	],
	"./ion-fab_3-ios.entry.js": [
		"wvyA",
		0,
		153
	],
	"./ion-fab_3-md.entry.js": [
		"NkKY",
		0,
		154
	],
	"./ion-img.entry.js": [
		"wHD8",
		155
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		"nf6t",
		0,
		156
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		"lg/V",
		0,
		157
	],
	"./ion-input-ios.entry.js": [
		"sdJS",
		0,
		158
	],
	"./ion-input-md.entry.js": [
		"uQUw",
		0,
		159
	],
	"./ion-item-option_3-ios.entry.js": [
		"Pa1g",
		0,
		160
	],
	"./ion-item-option_3-md.entry.js": [
		"KTnd",
		0,
		161
	],
	"./ion-item_8-ios.entry.js": [
		"Z51p",
		0,
		162
	],
	"./ion-item_8-md.entry.js": [
		"8bam",
		0,
		163
	],
	"./ion-loading-ios.entry.js": [
		"J3Yu",
		0,
		164
	],
	"./ion-loading-md.entry.js": [
		"N3W9",
		0,
		165
	],
	"./ion-menu_4-ios.entry.js": [
		"GEuc",
		0,
		166
	],
	"./ion-menu_4-md.entry.js": [
		"BHpw",
		0,
		167
	],
	"./ion-modal-ios.entry.js": [
		"mgaC",
		0,
		168
	],
	"./ion-modal-md.entry.js": [
		"EpFf",
		0,
		169
	],
	"./ion-nav_5.entry.js": [
		"qF1+",
		0,
		170
	],
	"./ion-popover-ios.entry.js": [
		"Gdks",
		0,
		171
	],
	"./ion-popover-md.entry.js": [
		"VgKV",
		0,
		172
	],
	"./ion-progress-bar-ios.entry.js": [
		"0PGG",
		0,
		173
	],
	"./ion-progress-bar-md.entry.js": [
		"h/Bu",
		0,
		174
	],
	"./ion-radio_2-ios.entry.js": [
		"5bK7",
		0,
		175
	],
	"./ion-radio_2-md.entry.js": [
		"pOmE",
		0,
		176
	],
	"./ion-range-ios.entry.js": [
		"5g9+",
		0,
		177
	],
	"./ion-range-md.entry.js": [
		"fD4w",
		0,
		178
	],
	"./ion-refresher_2-ios.entry.js": [
		"CXux",
		0,
		179
	],
	"./ion-refresher_2-md.entry.js": [
		"RODS",
		0,
		180
	],
	"./ion-reorder_2-ios.entry.js": [
		"IdzL",
		0,
		181
	],
	"./ion-reorder_2-md.entry.js": [
		"Ftzj",
		0,
		182
	],
	"./ion-ripple-effect.entry.js": [
		"STjf",
		183
	],
	"./ion-route_4.entry.js": [
		"k5eQ",
		0,
		184
	],
	"./ion-searchbar-ios.entry.js": [
		"l0q3",
		0,
		185
	],
	"./ion-searchbar-md.entry.js": [
		"mLlG",
		0,
		186
	],
	"./ion-segment_2-ios.entry.js": [
		"Iymp",
		0,
		187
	],
	"./ion-segment_2-md.entry.js": [
		"3msy",
		0,
		188
	],
	"./ion-select_3-ios.entry.js": [
		"rYLK",
		0,
		189
	],
	"./ion-select_3-md.entry.js": [
		"WOXB",
		0,
		190
	],
	"./ion-slide_2-ios.entry.js": [
		"F/Xn",
		191
	],
	"./ion-slide_2-md.entry.js": [
		"k8us",
		192
	],
	"./ion-spinner.entry.js": [
		"nI0H",
		0,
		193
	],
	"./ion-split-pane-ios.entry.js": [
		"edcM",
		194
	],
	"./ion-split-pane-md.entry.js": [
		"RyPD",
		195
	],
	"./ion-tab-bar_2-ios.entry.js": [
		"DP4G",
		0,
		196
	],
	"./ion-tab-bar_2-md.entry.js": [
		"gaXT",
		0,
		197
	],
	"./ion-tab_2.entry.js": [
		"TpdJ",
		0,
		198
	],
	"./ion-text.entry.js": [
		"ISmu",
		0,
		199
	],
	"./ion-textarea-ios.entry.js": [
		"xNZy",
		0,
		200
	],
	"./ion-textarea-md.entry.js": [
		"p1XJ",
		0,
		201
	],
	"./ion-toast-ios.entry.js": [
		"XGfm",
		0,
		202
	],
	"./ion-toast-md.entry.js": [
		"Y/uG",
		0,
		203
	],
	"./ion-toggle-ios.entry.js": [
		"WbT0",
		0,
		204
	],
	"./ion-toggle-md.entry.js": [
		"upP9",
		0,
		205
	],
	"./ion-virtual-scroll.entry.js": [
		"8Mb5",
		206
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "kLfG";
module.exports = webpackAsyncContext;